import React from "react";

const Loader = () => {
  return (
    <div className="my-2 text-center">
      <div
        class="spinner-border text-secondary m-1"
        style={{ height: "3rem", width: "3rem" }}
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div
        class="spinner-border text-secondary m-1"
        style={{ height: "3rem", width: "3rem" }}
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div
        class="spinner-border text-secondary m-1"
        style={{ height: "3rem", width: "3rem" }}
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
